"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getGaIds = exports.checkIfGaSessionIdNewer = exports.storeGaIds = void 0;
const ldLocalStorage_1 = require("./ldLocalStorage");
/**
 * Saves GA3 or GA4 clientID or sessionID to LD localStorage.
 * @param {string | undefined} id GA3 Property ID or GA4 Measurement ID
 * @param {GaIdType} type type of ID we want to retrieve (session or client)
 * @param {ILDTransactionMonitorPayload} payloadCallback ldPayload contents
 * @returns {Promise<void>} promise response saved to LD localStorage
 */
const storeGaIds = async (id, type, payloadCallback) => {
    const clientId = await (0, exports.getGaIds)(id, type);
    if (typeof clientId !== "string")
        return;
    switch (type) {
        case "client_id":
            payloadCallback["_google-clientID"] = clientId;
            break;
        case "session_id":
            payloadCallback["_ga4session-clientID"] = clientId;
            break;
        default:
            break;
    }
};
exports.storeGaIds = storeGaIds;
/**
 * Checks if GA4 session has expired and if it is
 * newer in GA cookie than in LD localStorage.
 * @param ga4MeasurementId GA4 Measurement ID
 * @returns {Promise<boolean | string>} promise returns new session_id or false
 */
const checkIfGaSessionIdNewer = async (ga4MeasurementId) => {
    const getStoredIds = (0, ldLocalStorage_1.getLDLocalStorage)();
    const storedGa4SessionId = getStoredIds === null || getStoredIds === void 0 ? void 0 : getStoredIds["_ga4session-clientID"];
    if (!ga4MeasurementId || !storedGa4SessionId) {
        return false;
    }
    const latestGa4SessionId = await (0, exports.getGaIds)(ga4MeasurementId, "session_id");
    return latestGa4SessionId !== storedGa4SessionId ? latestGa4SessionId : false;
};
exports.checkIfGaSessionIdNewer = checkIfGaSessionIdNewer;
/**
 * Fetches clientID or sessionID from GA3 or GA4.
 * @param {string | undefined} id - GA3 Property ID or GA4 Measurement ID
 * @param {string} type - type of ID we want to retrieve (session or client)
 * @returns {Promise<string | undefined>} promise resolved with clientID or sessionID
 */
const getGaIds = async (id, type) => new Promise((resolve, reject) => {
    if (typeof id === "undefined")
        return reject(new Error("No GA ID provided"));
    try {
        return gtag("get", id, type, resolve);
    }
    catch (error) {
        reject(error);
    }
});
exports.getGaIds = getGaIds;
